import { useQuery } from "react-query";

import { IpdbSourcePlay, fetchAllPlayTo3DDataPrivateSources } from "api/ipdp";

export const GEO_MODEL_ACCESS_QUERY_KEYS = {
  geoModelAccess: "geoModelAccess"
};

/**
 * @param enabled gate the request off for callers that render for every user.
 * `/sources/admin` returns the whole org's private models with their access
 * lists and has no server-side role check, so it must not be fetched from
 * surfaces that render regardless of role.
 */
export default function useGeoModelAccessQuery(enabled = true) {
  const queryInfo = useQuery<IpdbSourcePlay[]>({
    queryKey: [GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess],
    queryFn: fetchAllPlayTo3DDataPrivateSources,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: 2,
    select: (data) => {
      // Sort the data alphabetically by source name for consistent ordering
      return [...data].sort((a, b) => a.source.localeCompare(b.source));
    },
    onError: () => {
      // Error will be handled by React Query
    }
  });

  return {
    ...queryInfo,
    geoModels: queryInfo.data || []
  };
}
